import React, { RefObject, useState } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import className from "classnames";
import { Plan, PlanDetailsPageSection } from "../../../@types";
import {
  useTranslate,
  isMaPlanType,
  hideStarRatings,
  isMedicareAdvantageType,
} from "../../../helpers";
import { PlanDetailSection } from "../components";
import { useFlags } from "launchdarkly-react-client-sdk";
import OverallStarRating from "./OverallStarRating";
import HealthPlanStarRatings from "./HealthPlanStarRatings";
import DrugPlanStarRatings from "./DrugPlanStarRatings";

export const StarRatingsSection: React.FunctionComponent<{
  plan: Plan;
  sectionRef: RefObject<HTMLDivElement>;
}> = ({ plan, sectionRef }) => {
  const { enableNextPlanYearStarRatings, mctCurrentPlanYear } = useFlags();
  const t = useTranslate();
  const [expandAll, setExpandAll] = useState(false);

  return (
    <PlanDetailSection
      id={PlanDetailsPageSection.STAR_RATINGS}
      sectionRef={sectionRef}
      title={t("plan_stars.medicare.star_ratings")}
      className="StarRatingsSection"
      headingAddOn={
        <Button
          className="StarRatingsSection__expandAll"
          onClick={() => {
            setExpandAll(!expandAll);
          }}
          aria-expanded={expandAll}
        >
          <div className="ds-u-display--flex ds-u-align-items--center">
            <i
              className={className(
                "ds-u-margin-right--1",
                { "fas fa-plus ": !expandAll },
                { "fas fa-minus": expandAll }
              )}
            />
            {expandAll
              ? t("plan_stars.collapse_all")
              : t("plan_stars.expand_all")}
          </div>
        </Button>
      }
    >
      <OverallStarRating
        starRating={plan.overall_star_rating}
        highPerforming={plan.high_performing}
        lowPerforming={plan.low_performing}
        planYear={plan.contract_year}
      />

      {!hideStarRatings(plan.contract_year, {
        enableNextPlanYearStarRatings,
        mctCurrentPlanYear,
      }) && (
        <>
          {isMedicareAdvantageType(plan.plan_type) && (
            <HealthPlanStarRatings plan={plan} expandAll={expandAll} />
          )}

          {!isMaPlanType(plan.plan_type) && (
            <DrugPlanStarRatings plan={plan} expandAll={expandAll} />
          )}
        </>
      )}
    </PlanDetailSection>
  );
};
